import React from "react";
import moment from "moment";
import { styled } from "@mui/material/styles";
import { Box, Button, Grid, Stack, Typography } from "@mui/material";
import Modal from "@/components/modal";
import { toast } from "sonner";
import { useDeletePopularSearchMutation } from "@/app/features/popularSearch/popularSearchApiSlice";

const CarDetails = styled(Box)`
  overflow-y: auto;
  height: 300px;
`;

function CarRow({ name, value }) {
  return (
    <Grid container mb={1}>
      <Grid item xs={12} sm={2}>
        {name}
      </Grid>

      <Grid item xs={12} sm={10}>
        {value}
      </Grid>
    </Grid>
  );
}

export default function PopularSearchModal({
  open,
  handleClose,
  selectedPopularSearch,
}) {
  const [deletePost, { isLoading }] = useDeletePopularSearchMutation();

  const handleDelete = async () => {
    try {
      await deletePost(selectedPopularSearch.id);
      handleClose();
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
    }
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Typography
        variant="h6"
        sx={{
          mb: 2,
        }}
      >
        Are you sure you want to delete {selectedPopularSearch.name} ?
      </Typography>

      <CarDetails>
        <CarRow name="Name" value={selectedPopularSearch.name} />
        <CarRow name="Tile header" value={selectedPopularSearch.tileHeader || "Buying guide"} />
        <CarRow name="Guide article URL" value={selectedPopularSearch.articleUrl} />

        {selectedPopularSearch.image && (
          <CarRow
            name="Image"
            value={
              <img
                src={`${process.env.REACT_APP_IMAGE_URL}/popular-search/${selectedPopularSearch.image}`}
                alt={selectedPopularSearch.name}
                width={150}
                height={200}
                style={{
                  objectFit: "contain",
                }}
              />
            }
          />
        )}

        <CarRow
          name="Created On"
          value={moment(selectedPopularSearch.createdAt).format("MMMM Do YYYY")}
        />
      </CarDetails>

      <Stack direction="row" alignItems="center" justifyContent="center" mt={2}>
        <Button
          variant="contained"
          fullWidth
          onClick={handleDelete}
          disabled={isLoading}
        >
          Delete
        </Button>
      </Stack>
    </Modal>
  );
}
